export default {
  'submit-success': 'Submitted successfully',
  'business-vf.title': 'business-verification',
  'business-vf.link': 'Business Account Verification',
  'business-vf.personalLink': 'Personal Identity Verification',
  'business-vf.step-name-1': 'Fill in business info',
  'business-vf.step-name-2': 'Upload business license',
  'business-vf.file-tip': 'Click to upload your business license in PDF, PNG or JPEG format.',
  'business-vf.note-1': 'Make sure that your registration number corresponds to the number mentioned in your business license',
  'business-vf.note-2': 'Make sure your Business name, number and address are clearly visible on the photo',
  'business-vf.input-name-1': 'entity name',
  'business-vf.input-name-2': 'registration number',
  'business-vf.input-name-3': 'date of incorporation',
  'business-vf.input-name-4': 'registration address',
  'business-vf.input-name-5': 'Nature of business',
  'business-vf.placeholder': 'Detailed address, City, Country | eg: 163,  Haussman street, Paris, France',
};
